import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import { getBoot } from '@/lib/boot';

export type PublicBranding = {
  platform_name?: string;
  support_email?: string;
  tagline?: string;
};

/** Fetches the platform's public branding (from Platform → Genel Ayarlar).
 *  Used by the shell components so the header/footer reflect whatever
 *  the admin configured without requiring auth. Long staleTime — the
 *  value barely changes once set.
 *
 *  Seeded from window.__BOOT__.branding (injected by the worker into
 *  index.html) so the first render already has the right values. */
export function useBranding() {
  return useQuery({
    queryKey: ['public', 'branding'],
    queryFn: () => api.get<{ branding: PublicBranding }>('/api/public/branding'),
    staleTime: 10 * 60 * 1000,
    initialData: () => {
      const boot = getBoot();
      return boot.branding ? { branding: boot.branding } : undefined;
    },
  });
}

/** Convenience: just the name, with a fallback so components never have
 *  to guard against undefined. */
export function usePlatformName(fallback = 'CMS Hub'): string {
  const { data } = useBranding();
  return data?.branding.platform_name?.trim() || fallback;
}
